// eslint-disable
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Box, ButtonBase, makeStyles } from '@material-ui/core';
import _, { isArray } from 'lodash';
import { useSelector } from 'react-redux';
import StyleButton from '../../../../components/StyleButton';
import { AddIcon, EditIcon } from '../../../../components/Icon';
import RobotImg from '../../../../static/images/robot.png';
import { ReactComponent as EmptyRobot } from '../../../../static/images/emptyRobot.svg';
import { teleVisitAPI } from '../../../../apis';
import { i18n } from '../../../../language';
import { authNameE } from '../../../../utils/userFuncs';
import RegisterRobot from './Popup/RegisterRobot';
import EditRobot from './Popup/EditRobot';
const useStyles = makeStyles(() => ({
  title: {
    fontFamily: 'NotoSans-Bold',
    fontSize: '1.5rem',
    lineHeight: '2rem',
    color: '#333333',
  },
  subTitle: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '0.875rem',
    color: '#7d86a9',
  },
  cardTitle: {
    fontFamily: 'NotoSans-Bold',
    fontSize: '1.125rem',
    color: '#538fff',
  },
  robot: {
    width: '4.563rem',
    height: '4.563rem',
    borderRadius: '8px',
    backgroundColor: '#fff',
    border: 'solid 1px #538fff',
    marginRight: '1.25rem',
  },
  robotTitle: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '0.875rem',
    color: '#666666',
  },
  robotContent: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    color: '#7d86a9',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  robotBorder: {
    borderRadius: '4px',
    width: '0.125rem',
    height: '2.938rem',
    backgroundColor: '#d9d9d9',
    margin: '0 2.5rem',
  },
  editBtn: {
    width: '2.25rem',
    minWidth: '2.25rem',
    height: '2.25rem',
    minHeight: '2.25rem',
    borderRadius: '10px',
    backgroundColor: '#538fff',
  },
  editIcon: {
    fontSize: '1rem',
    color: '#fff',
  },
  emptyContent: {
    fontSize: '1rem',
    color: '#707090',
  },
}));

const Robot = () => {
  const classes = useStyles();
  const [registerDialog, setRegisterDialog] = useState(false);
  const [editDialog, setEditDialog] = useState(false);
  const [editData, setEditData] = useState(null);
  const [formData, setFormData] = useState([]);
  const [dropdownData, setDropdownData] = useState({});
  const roleMap = useSelector((state) => state.roleMap);
  //  getRobotList
  const getRobotListApi = useCallback(async () => {
    try {
      const { result } = await teleVisitAPI.getRobotList();
      setFormData(result);
    } catch (error) {}
  }, []);

  const registerHandler = useCallback(
    (props) => (id) => {
      setRegisterDialog(props);
    },
    []
  );
  // add  Register Robot
  const robotRegisterApi = useCallback(async (data) => {
    try {
      await teleVisitAPI.postRobotRegister(data);
      setRegisterDialog(false);
      await getRobotListApi();
    } catch (error) {}
  }, []);
  // update Register Robot
  const updateRobotApi = useCallback(async (data) => {
    try {
      await teleVisitAPI.postUpdateRobot(data);
      setEditDialog(false);
      await getRobotListApi();
    } catch (error) {}
  }, []);
  // Disconnect Register Robot
  const disconnectRobot = useCallback(async (robotData) => {
    try {
      await teleVisitAPI.postDisconnectRobot(robotData);
      setEditDialog(false);
      await getRobotListApi();
    } catch (error) {}
  }, []);
  const editHandler = useCallback(
    (props) => (editData) => (event) => {
      setEditData(editData);
      setEditDialog(props);
    },
    []
  );
  useEffect(() => {
    (async () => {
      await getRobotListApi();
    })();
  }, [getRobotListApi]);

  const staticDataListApi = useCallback(async () => {
    try {
      const { result } = await teleVisitAPI.getStaticDataList();
      setDropdownData(result);
    } catch (error) {}
  }, []);

  useEffect(() => {
    (async () => {
      await staticDataListApi();
    })();
  }, [staticDataListApi]);

  return (
    <>
      <Box display="flex" flexDirection="column" pt="1.25rem">
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <div className={classes.title}>{i18n.t('TELEVISIT_SETTING_TELEVISIT_ROBOT')}</div>
          {roleMap[authNameE.setting_televisit_manage_robot_register_update] && (
            <StyleButton
              text={i18n.t('TELEVISIT_SETTING_REGISTER_ROBOT')}
              type="fill"
              Icon={AddIcon}
              width="12.5rem"
              height="3rem"
              fontStyle={{ fontFamily: 'NotoSans-Bold' }}
              onClick={registerHandler(true)}
            />
          )}
        </Box>
        <div className={classes.subTitle}>{`${i18n.t('TELEVISIT_SETTING_QUANTITY')} ${formData.length}`}</div>
        {formData.length > 0 ? (
          <Box display="flex" flexDirection="column" pt="1.875rem" pb="1rem" gridRowGap="1.25rem">
            {_.map(formData, (item, index) => {
              return (
                <Card
                  name={index}
                  editHandler={editHandler(true)(item)}
                  dropdownData={dropdownData}
                  item={item}
                  key={index}
                />
              );
            })}
          </Box>
        ) : (
          <Box display="flex" alignItems="center" justifyContent="center" height="50vh">
            <Box display="flex" flexDirection="column" gridGap="1.25rem" alignItems="center">
              <EmptyRobot />
              <div className={classes.emptyContent}>{i18n.t('TELEVISIT_SETTING_EMPTY_ROBOT')}</div>
            </Box>
          </Box>
        )}
      </Box>
      {registerDialog && <RegisterRobot onClose={registerHandler(false)} robotRegisterApi={robotRegisterApi} />}
      {editDialog && (
        <EditRobot
          onClose={editHandler(false)()}
          editData={editData}
          updateRobotApi={updateRobotApi}
          disconnectRobot={disconnectRobot}
        />
      )}
    </>
  );
};

const Card = ({ name, editHandler, item, dropdownData }) => {
  const classes = useStyles();
  const language = useSelector((state) => state.settings.language);
  const roleMap = useSelector((state) => state.roleMap);
  const robotStatus = useMemo(() => {
    if (isArray(dropdownData.statusData)) {
      const statusLabel = _.filter(dropdownData.statusData, (statusItem) => statusItem.dataKey === 'RobotStatus').find(
        (statusItem) => Number(statusItem.dataValue) === Number(item?.robotStatus)
      );
      return language === 'en-us' ? statusLabel.descEN : statusLabel.descCH;
    }
    return null;
  }, [dropdownData.statusData, language, item?.robotStatus]);

  return (
    <Box display="flex" flexDirection="column">
      <div className={classes.cardTitle}>{item?.robotName}</div>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        bgcolor="#f5faff"
        borderRadius="15px"
        p="1.25rem 1.875rem 1.25rem 1.438rem"
        width="100%"
        height="7.688rem"
      >
        <Box display="flex" alignItems="center" flex="1" gridGap="0.5rem">
          <div>
            <img src={RobotImg} className={classes.robot} alt="robot" />
          </div>
          <Box display="flex" flexDirection="column" justifyContent="space-between" gridRowGap="0.625rem" width="30%">
            <div className={classes.robotTitle}>{i18n.t('TELEVISIT_SETTING_STATUS')}</div>
            <div className={classes.robotContent} title={robotStatus}>
              {robotStatus}
            </div>
          </Box>
          <Box
            display="flex"
            flexDirection="column"
            justifyContent="space-between"
            gridRowGap="0.625rem"
            mr="2.5rem"
            width="30%"
          >
            <div className={classes.robotTitle}>{i18n.t('TELEVISIT_SETTING_SERIAL_NUMBER')}</div>
            <div className={classes.robotContent}>{item?.robotSerialNumber}</div>
          </Box>
        </Box>
        {roleMap[authNameE.setting_televisit_manage_robot_register_update] && (
          <ButtonBase className={classes.editBtn} onClick={editHandler}>
            <EditIcon className={classes.editIcon} />
          </ButtonBase>
        )}
      </Box>
    </Box>
  );
};

export default Robot;
